import React from "react";
import { useBootstrapTheme } from "../../contexts/BootstrapThemeContext";
import { EffectThemeRangeProps } from "../../types/effectTheme";

const EffectThemeRange= ({
  value,
  onChange,
  min,
  max,
  step = 1,
  label,
  minDescription,
  maxDescription,
  className,
  disabled,
  name,
  id,
  showValue = false,
  showCenterValue=false,
  centerValue=0,
  onCenterClick
}: EffectThemeRangeProps) => {
  const { effectiveTheme } = useBootstrapTheme();
  const isDark = effectiveTheme === "dark";

  // Farben im gleichen Look wie Dropdown
  const vars: React.CSSProperties = {
    ["--effect-accent" as any]: isDark ? "#60a5fa" : "#3b82f6",

    // Track = bläulicher Verlauf
    ["--effect-track" as any]: isDark
      ? "linear-gradient(90deg, rgba(96,165,250,0.45), rgba(37,99,235,0.30))"
      : "linear-gradient(90deg, rgba(59,130,246,0.35), rgba(37,99,235,0.22))",

    ["--effect-track-border" as any]: isDark
      ? "1px solid rgba(96,165,250,0.25)"
      : "1px solid rgba(59,130,246,0.18)",

    // Thumb
    ["--effect-thumb-bg" as any]: isDark
      ? "linear-gradient(145deg, rgba(226,232,240,0.95), rgba(148,163,184,0.90))"
      : "linear-gradient(145deg, rgba(255,255,255,0.98), rgba(226,232,240,0.92))",

    ["--effect-thumb-border" as any]: isDark
      ? "1px solid rgba(96,165,250,0.55)"
      : "1px solid rgba(59,130,246,0.40)",

    ["--effect-thumb-shadow" as any]: isDark
      ? "0 10px 24px rgba(96,165,250,0.22)"
      : "0 10px 24px rgba(59,130,246,0.16)",
  };

  const textStyle: React.CSSProperties = {
    color: isDark ? "rgba(226,232,240,0.75)" : "rgba(15,23,42,0.65)",
  };

  return (
    <div className={`effect-range ${className ?? ""}`} style={vars}>
      {(label || showValue) && (
        <div className="position-relative mb-2 text-center">
          <span className="small" style={{ color: isDark ? "rgba(226,232,240,0.9)" : "rgba(15,23,42,0.9)" }}>
            {label ?? ""}
          </span>
          {showValue && (
            <span className="small" style={textStyle}>
              {value}
            </span>
          )}
        </div>
      )}

      <input
        id={id}
        name={name}
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(Number(e.currentTarget.value))}
        className="form-range effect-range__input"
      />

      <div className="d-flex justify-content-between small position-relative" style={textStyle}>
        <span>{minDescription ?? min}</span>

        {showCenterValue && (
            <button
                type="button"
                className="btn btn-link p-0 small position-absolute start-50 translate-middle-x"
                style={{ ...textStyle, textDecoration: "none" }}
                onClick={() => onCenterClick?.()}
            >
                {centerValue ?? 0}
            </button>
        )}

        <span>{maxDescription ?? max}</span>
    </div>
    </div>
  );
};

export default EffectThemeRange;
